/**
 * Slug determinístico y legible para códigos internos.
 * "Coordinador Zonal Norte" → "coordinador_zonal_norte"
 * "Quito - Centro (Piso 3)"  → "quito_centro_piso_3"
 * Feb-2026 · Requerimiento Xiomara: los códigos se generan automáticamente,
 *            no se piden al usuario al crear roles/sucursales/zonas.
 */
export function slugify(input, { maxLen = 40 } = {}) {
  return (input || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // quitar acentos
    .replace(/&/g, " y ")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, maxLen);
}
